import React, { useState, useContext } from "react";
import { GlobalContext } from "../../../context/globalContext";
import { Form } from "../../_molecules/_form/Form";
import { FormSelectSimple } from "../../_atoms/_form-input-simple/FormSelectSimple";
import { BtnGroup } from "../../_atoms/_btn-simple/BtnGroup";
import { BtnSimple } from "../../_atoms/_btn-simple/BtnSimple";
import { HeroSub } from "../../_molecules/_hero-sub/HeroSub";
import { SpecSheet } from "../../_molecules/_specsheet/SpecSheet";
import { sendAnalytics } from "../../../utils/analytics";
import "./_bsi-content.scss";
import { Alert } from "../_alert/Alert";

//import {PropTypes} from "prop-types"
export const BsiContent = ({ data }) => {
  //TODO Turn this into a hook
  const { state: stateGlobal } = useContext(GlobalContext);
  const { brand, carSpecs, provinceValue, outletName, outlet } = stateGlobal;
  // const brand = "mini";
  const content = require(`../../../data/${brand}-lang.es.json`);
  const homeTxt = content.home;
  const searchTxt = content.search;
  const external_links = content.external_links;
  //Exportamos los precios
  const tabs = Object.values(data.tabs);

  //Calculamos la antiguedad del coche
  const { firstRegistrationDate } = data;

  //convertimos la fecha a formato inglés.
  const temp = firstRegistrationDate.split(".");
  let firstRegistrationDateUS = temp[1] + "/" + temp[0] + "/" + temp[2];

  // //la fecha de hoy...
  let todayDate = new Date();
  const dd = String(todayDate.getDate()).padStart(2, "0");
  const mm = String(todayDate.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = todayDate.getFullYear();
  todayDate = new Date(yyyy, mm - 1, dd);

  firstRegistrationDateUS = new Date(firstRegistrationDateUS);

  // To calculate the time difference of two dates
  let antiquity = todayDate.getTime() - firstRegistrationDateUS.getTime();

  // To calculate the no. of days between two dates
  antiquity = antiquity / (1000 * 3600 * 24 * 365);

  //console.log("antiguedad: " + antiquity);

  //Cual es el ID del array con paquete 07NA? Para mostrarl sus datos por defecto

  //Cuando es un vehículo de menos de 2 años, se muestran por defecto el 4/60 07DD
  //Cuando es un vehículo de más de 2 años, se muestran por defecto el 4/60 07DD

  // console.log(tabs.findIndex((item) => item.contractType === "07NA"));
  let indexSelected;

  if (antiquity > 2) {
    if (tabs.findIndex((item) => item.contractType === "U7US") > -1) {
      indexSelected = tabs.findIndex((item) => item.contractType === "U7US");
    } else if (tabs.findIndex((item) => item.contractType === "U7DD") > -1) {
      indexSelected = tabs.findIndex((item) => item.contractType === "U7DD");
    } else {
      indexSelected = 0;
    }
  } else {
    if (tabs.findIndex((item) => item.contractType === "07DD") > -1) {
      indexSelected = tabs.findIndex((item) => item.contractType === "07DD");
    } else if (tabs.findIndex((item) => item.contractType === "07DE") > -1) {
      indexSelected = tabs.findIndex((item) => item.contractType === "07DE");
    } else {
      indexSelected = 0;
    }
  }

  // console.log("index: " + indexSelected);

  if (indexSelected < 0) {
    indexSelected = 0;
  }

  //console.log(indexSelected);

  const [state, setState] = useState({
    carData: data,
    name: data.tabs[indexSelected].name,
    price: parseInt(data.tabs[indexSelected].price),
    pricePlus: data.tabs[indexSelected].price_plus ? parseInt(data.tabs[indexSelected].price_plus) : false,
    instalments: 1,
    instalmentsPlus: 1,
    priceCalculated: parseInt(data.tabs[indexSelected].price),
    pricePlusCalculated: parseInt(data.tabs[indexSelected].price_plus),
    contract: data.tabs[indexSelected].contractType,
  });

  const {
    name,
    price,
    pricePlus,
    priceCalculated,
    pricePlusCalculated,
    instalments,
    instalmentsPlus,
    carData,
    contract,
  } = state;

  // Explicación de como vamos a calcular el precio:
  // price y pricePlus es el precio anual, este precio va a ser estático, no se
  // modificara. Si necesitamos calcular mensualidades usaremos priceCalculated
  // y pricePlusCalculated, lo que hacemos es actualizar los instalments para
  // calcular el número de pagos y entonces dividir price y pricePlus por los instalments

  const GTMButtons = (eventGTM) => {
    //GTM
    window.dataLayer.push({
      event: eventGTM,
      modelo: carSpecs.ecode,
      provincia: provinceValue,
      taller: outletName,
      buno: outlet,
    });
  };

  const selectPacket = (e) => {
    const id = e.target.value;

    const newData = data.tabs.filter((item) => {
      if (item.contractType === id) {
        return item;
      } else {
        return;
      }
    });

    //Revisamos los installments para bajarlos a 1 si el precio es inferior a 500
    const { instalments, instalmentsPlus, price, pricePlus } = state;
    let instalmentsValue;
    let instalmentsValuePlus;
    price > 499 ? (instalmentsValue = 1) : (instalmentsValue = instalments);
    pricePlus > 499 ? (instalmentsValuePlus = 1) : (instalmentsValuePlus = instalmentsPlus);

    setState({
      ...state,
      instalments: instalmentsValue,
      instalmentsPlus: instalmentsValuePlus,
      priceCalculated: parseInt(newData[0].price / instalmentsValue),
      pricePlusCalculated: newData[0].price_plus ? parseInt(newData[0].price_plus / instalmentsValuePlus) : false,
      price: parseInt(newData[0].price),
      pricePlus: newData[0].price_plus ? parseInt(newData[0].price_plus) : false,
      name: e.target.options[e.target.selectedIndex].text,
    });
  };

  const calculatePayment = (type) => {
    return (e) => {
      //Dependiendo del coste de BSI la cuota mensual será de 12 o de 18
      let numInstalments = 12;
      let numInstalmentsPlus = 12;

      //console.log(numInstalmentsPlus);

      if (type === "plus") {
        const paymentTime = e.target.value;

        const { pricePlus } = state;
        paymentTime === "month"
          ? setState({
              ...state,
              instalmentsPlus: numInstalmentsPlus,
              pricePlusCalculated: parseFloat((pricePlus / numInstalmentsPlus).toFixed(2)).toLocaleString("es-ES"),
            })
          : setState({
              ...state,
              instalmentsPlus: 1,
              pricePlusCalculated: pricePlus,
            });
      } else {
        const paymentTime = e.target.value;

        const { price } = state;

        paymentTime === "month"
          ? setState({
              ...state,
              instalments: numInstalments,
              priceCalculated: parseFloat((price / numInstalments).toFixed(2)).toLocaleString("es-ES"),
            })
          : setState({
              ...state,
              instalments: 1,
              priceCalculated: price,
            });
      }
    };
  };

  function isExpiredRecently(data) {
    return (
      data &&
      data.type === null &&
      data.name === "" &&
      data.end_date === null &&
      data.is_upgraded === true
    );
  }

  function shouldShowPackageMessage(data) {
    if (isExpiredRecently(data)) return true;

    if (data.name) return true;
    return false;
  }

  const showMessage = shouldShowPackageMessage(data);
  const expiredRecently  = isExpiredRecently(data);

  return (
    <div className="bsi-content">
      <div className="false-background">
        <div className="container-grid bsi-content__intro">
          {showMessage && (
            <Alert css="alert--success bsi-alert">
              <ul className="list list--icons list--icons--md">
                <li>
                  <div className="text">
                    <svg className="icon">
                      <use xlinkHref="./svg/sprite.svg#form-success"></use>
                    </svg>
                    {expiredRecently
                    ? 'Las opciones que se muestran a continuación son ampliaciones en tiempo o kilometraje de tu paquete de mantenimiento expirado.'
                    : searchTxt.promotionInfoText.replace('%package', data.name)}
                  </div>
                </li>
              </ul>
            </Alert>
          )}

          <div className="texts">
            <span className="h5">{searchTxt.choiceMaintenance}</span>
          </div>
          <Form css="form--simple">
            <fieldset>
              <legend className="h5">{searchTxt.choiceDuration}</legend>
              <FormSelectSimple
                label="Elige la duracción"
                name="duration"
                onChange={(e) => {
                  selectPacket(e);
                  sendAnalytics("Click en duración", e.target.value);
                }}
                value={price}
                hideDefault={true}>
                {tabs.map((item, i) => {
                  return (
                    <option
                      key={item.contractType}
                      value={item.contractType}
                      selected={
                        (antiquity < 2 && item.contractType === "07DD") ||
                        item.contractType === "07DE" ||
                        (antiquity > 2 && item.contractType === "U7US") ||
                        item.contractType === "U7US"
                      }>
                      {item.name}
                    </option>
                  );
                })}
              </FormSelectSimple>
            </fieldset>
          </Form>
        </div>
      </div>
      <div
        className={`container-grid bsi-content__specs ${pricePlus ? "two-spec-sheets" : "one-spec-sheet"}`}>
        {!isNaN(price) && (
          <SpecSheet
            price={priceCalculated}
            originalPrice={price}
            title={
              antiquity < 2 ? (
                <span className="h3">{homeTxt.specSheet1Title}</span>
              ) : (
                <span className="h3">{homeTxt.specSheet1Title} { carData.business === 'UC' ? 'Next' : '' }</span>
              )
            }
            subtitle={
              <button
                type="button"
                className="specSheet-subtitle"
                onClick={() => sendAnalytics("Click en ¿Qué incluye?", homeTxt.specSheet1SubTitle)}
              >
                {homeTxt.specSheet1SubTitle}
              </button>
            }
            button={homeTxt.specSheet1Button}
            small={homeTxt.specSheet1Small}
            aria={homeTxt.specSheet1SubTitle}
            specs={homeTxt.specSheet1Prods}
            monthly={instalments < 2 ? false : true}
            onChange={calculatePayment("regular")}
            duration={name}
            showSelect={price > 499 ? true : false}
            selectText="Pago 12 meses financiado"
          />
        )}
        {pricePlus && (
          <SpecSheet
            price={pricePlusCalculated}
            originalPrice={pricePlus}
            title={homeTxt.specSheet2Title}
            subtitle={homeTxt.specSheet2SubTitle}
            button={homeTxt.specSheet2Button}
            small={homeTxt.specSheet2Small}
            aria={homeTxt.specSheet2SubTitle}
            specs={homeTxt.specSheet2Prods}
            monthly={instalmentsPlus < 2 ? false : true}
            onChange={calculatePayment("plus")}
            duration={name}
            showSelect={pricePlus > 499 ? true : false}
            selectText="Pago 12 meses financiado"
          />
        )}
      </div>

      <HeroSub css="container-grid hero-sub--center">
        <span className="h3">¿CÓMO CONTRATARLO?</span>
        <BtnGroup>
          <BtnSimple
            href={`${external_links.online_shop_appointment}${outlet.split("/")[0]}`}
            css="btn-simple--1"
            aria={searchTxt.btnGroup.online_shop_appointment}
            children={searchTxt.btnGroup.online_shop_appointment}
            target="_blank"
            onClick={() => {
              GTMButtons("sc_pedir_cita_bsi");
              sendAnalytics("Click en Pedir Cita", searchTxt.btnGroup.online_shop_appointment);
            }}
            type="link"
          />
          {brand == "bmw" && (
            <BtnSimple
              href={external_links.connected_drive}
              css="btn-simple--1 btn-simple--6"
              aria={searchTxt.btnGroup.connected_drive}
              children={searchTxt.btnGroup.connected_drive}
              target="_blank"
              onClick={() => {
                GTMButtons("sc_bmw_store");
                sendAnalytics("Click en Visitar BMW Store", searchTxt.btnGroup.connected_drive);
              }}
              type="link"
            />
          )}

          {brand == "mini" && (
            <BtnSimple
              href={external_links.connected_drive}
              css="btn-simple--1 btn-simple--6"
              aria={searchTxt.btnGroup.connected_drive}
              children={searchTxt.btnGroup.connected_drive}
              target="_blank"
              onClick={() => {
                GTMButtons("sc_mini_store");
                sendAnalytics("Click en Visitar MINI Store", searchTxt.btnGroup.connected_drive);
              }}
              type="link"
            />
          )}
          <BtnSimple
            href={external_links.find_shop}
            css="btn-simple--1 btn-simple--5"
            aria={searchTxt.btnGroup.find_shop}
            children={searchTxt.btnGroup.find_shop}
            target="_blank"
            onClick={() => {
              GTMButtons("sc_localiza_concesionario");
              sendAnalytics("Click en Localizar Concesionario", searchTxt.btnGroup.find_shop);
            }}
            type="link"
          />
        </BtnGroup>
      </HeroSub>
      <div className="container-grid bsi-content__legals">
        <small>
          {/* Si el paquete empieza por U... es un coche viejo */}
          {/* {contract[0] === "U" && searchTxt.legalAntiquity}
          {contract[0] !== "U" && searchTxt.legalAntiquityNew} */}
          {carSpecs.is_upgraded
            ? [contract[0] === "U" ? searchTxt.legalAntiquity_B : searchTxt.legalAntiquity_A]
            : [contract[0] === "U" ? searchTxt.legalAntiquity_C : searchTxt.legalAntiquity_A]}
        </small>
        {/* <small>
          <sup>2</sup>
          <span dangerouslySetInnerHTML={{ __html: searchTxt.legalPrice }}></span>
        </small> */}
      </div>
    </div>
  );
};
